import React, { ReactElement, useState, ChangeEvent } from 'react'
import {
  StyledCard,
  StyledInputs,
  StyledButtons,
} from '../../../../../styled-components'

import Icon from '../../../../../../icon'
import Inputfield from '../../../../../../input/input-field'
import Button from '../../../../../../button'
import Card from '../../../../../card'

interface AnswerProps {
  answer: string
  onEditClick: (answer: string | null) => void
  onDeleteClick: (answer: string | null) => void
}

const Answer = ({
  answer,
  onEditClick,
  onDeleteClick,
}: AnswerProps): ReactElement => {
  const [answerEdit, setAnswerEdit] = useState<string>(
    answer === ' ' ? answer : ''
  )
  const [editMod, setEditMod] = useState(answer === ' ')

  return (
    <StyledCard>
      {editMod ? (
        <StyledInputs>
          <Inputfield
            labelName=""
            type="text"
            value={answerEdit}
            onValueChange={(event: ChangeEvent<HTMLInputElement>) =>
              setAnswerEdit(event.target.value)
            }
          />
          <StyledButtons>
            <Button
              onClick={() => {
                onEditClick(answerEdit)
                setAnswerEdit('')
                setEditMod(false)
              }}
              color="red"
            >
              <Icon name="entypo:check" />
            </Button>

            <Button
              onClick={() => {
                onDeleteClick(answerEdit)
                setAnswerEdit('')
                setEditMod(false)
              }}
              color="white"
            >
              <Icon name="fluent:delete-28-regular" />
            </Button>
          </StyledButtons>
        </StyledInputs>
      ) : (
        <Card
          element={answer}
          onClickEdit={() => {
            setAnswerEdit(answer)
            setEditMod(true)
          }}
        />
      )}
    </StyledCard>
  )
}

export default Answer
